import PreviewQuestion from './container/PreviewQuestion';

export default PreviewQuestion;



// WEBPACK FOOTER //
// ./src/views/PreviewQuestion/index.js